/**
 * Created by PuTi(编程即菩提) 11/18/17.
 */
var nb = require('../nb');
module.exports = nb.define({
    view: {
        'class': [nb.bind('style')],
        $html: {
            'class': 'header-content clearfix',
            $html: [{
                class: 'header-logo',
                $html: {
                    class: 'logo',
                    tag: 'a',
                    href: 'index.html',
                    $html: {
                        tag: 'img',
                        src: './image/logo/logo.png'
                    }
                }
            }, {
                'class': 'header-nav',
                'data-loginReady': nb.bind('loginReady'),
                'data-onlyWater':nb.bind('onlyWater'),
                $html: [{
                    'class': 'nav-list clearfix',
                    $html: [{
                        'class': 'nav-item index-item',
                        tag: 'a',
                        href: 'index.html',
                        // target: '_blank',
                        $text: nb.bind('homepageText')
                    }, {
                        'class': 'nav-item brands-item',
                        tag: 'a',
                        href: 'brands.html',
                        // target: '_blank',
                        $text: nb.bind('brandText')
                    }, {
                        'class': 'nav-item productList-item',
                        tag: 'a',
                        href: 'productList.html',
                        // target: '_blank',
                        $text: nb.bind('productText')
                    }, {
                        'class': 'nav-item nav-item-service console-item',
                        tag: 'a',
                        href: 'console.html',
                        // target: '_blank',
                        $text: nb.bind('serviceText')
                    }]
                }, {
                    'class': ['nav-icon clearfix'],
                    $html: [{
                        'class': ['icon-text item-user'],
                        'data-uk-dropdown': '{pos:"bottom-center"}',
                        $html: [{
                            tag: 'a',
                            'class': 'text btn-dropdown',
                            title: nb.bind('loginText'),
                            href: nb.bind('loginHref'),
                            $text: nb.bind('loginText')
                        }, {
                            'class': 'user-dropdown uk-dropdown',
                            $html: [{
                                tag: 'a',
                                href: 'inquiryList.html',
                                $text: nb.bind('productListText')
                            },{
                                tag: 'a',
                                href: 'order.html',
                                $text: nb.bind('orderText')
                            }, {
                                tag: 'a',
                                href: 'invoiceList.html',
                                $text: nb.bind('invoiceText')
                            }, {
                                tag: 'a',
                                href: 'accountInfo.html',
                                $text: nb.bind('accountText')
                            }, {
                                tag: 'a',
                                href: 'address.html',
                                $text: nb.bind('addressText')
                            }, {
                                tag: 'a',
                                $name: 'logOff',
                                $text: nb.bind('logOffText')
                            }]
                        }]
                    }, {
                        'class': 'icon-text item-cart',
                        'data-uk-dropdown': '{pos:"bottom-center"}',
                        $html: [{
                            tag: 'a',
                            'class': 'btn-dropdown iconfont icon-gouwuche cart-icon',
                            href: nb.bind('cartHref'),
                            $html: {
                                tag: 'small',
                                'class': nb.bind('countVisible'),
                                $text: nb.bind('totalCountTop')
                            }
                        }, {
                            'class': ['cart-dropdown uk-dropdown', nb.bind('hasCart')],
                            $html: [{
                                'class': 'dropdown-title',
                                $text: nb.bind('cartTitle')
                            }, {
                                'class': 'empty-cart',
                                $html: [{
                                    tag: 'i',
                                    'class': 'iconfont icon-cart-empty'
                                }, {
                                    'class': 'cart-empty-text',
                                    $text: nb.bind('cartEmptyText')
                                }]
                            }, {
                                'class': 'cart-list-content',
                                $html: [{
                                    'class': 'cart-list',
                                    $html: {
                                        $type: nb.view.List,
                                        $model: 'cartList'
                                    }
                                }, {
                                    'class': 'total-text clearfix',
                                    $html: [{
                                        tag: 'span',
                                        $html: [{
                                            tag: 'font',
                                            $html: nb.bind('totalAmountPrefix')
                                        }, {
                                            tag: 'em',
                                            $text: nb.bind('totalAmountText')
                                        }, {
                                            tag: 'font',
                                            $html: nb.bind('totalAmountSuffix')
                                        }]
                                    }, {
                                        tag: 'span',
                                        $text: nb.bind('totalAmount')
                                    }]
                                }, {
                                    'class': 'btn-box',
                                    $html: {
                                        tag: 'a',
                                        href: 'cart.html',
                                        'class': 'btn btn-solid-gold btn-block',
                                        $text: nb.bind('goCartText')
                                    }
                                }]
                            }]
                        }]
                    }, {
                        $name: 'languageText',
                        'class': 'icon-text',
                        $html: {
                            tag: 'span',
                            $text: nb.bind('languageText')
                        }
                    }, {
                        'class': 'icon-text item-sale',
                        'data-uk-dropdown': '{pos:"bottom-center"}',
                        $html: [{
                            tag: 'span',
                            'class': 'btn-dropdown iconfont icon-kefu1 cart-icon',
                            href: 'javascript:void(0);'
                        }, {
                            'class': ['sale-dropdown uk-dropdown', nb.bind('hasSale')],
                            $html: [{
                                'class': 'dropdown-title',
                                $text: nb.bind('saleTitle')
                            }, {
                                'class': 'sale-list-content',
                                $html: [{
                                    'class': 'info-text clearfix',
                                    $html: [{
                                        tag: 'span',
                                        $html: nb.bind('saleName')
                                    }, {
                                        tag: 'span',
                                        // 'class': 'uk-text-truncate',
                                        $text: nb.bind('salesName')
                                    }]
                                }, {
                                    'class': 'info-text clearfix',
                                    $html: [{
                                        tag: 'span',
                                        $html: nb.bind('salePhone')
                                    }, {
                                        tag: 'span',
                                        // 'class': 'uk-text-truncate',
                                        $text: nb.bind('salesPhone')
                                    }]
                                }, {
                                    'class': 'info-text clearfix',
                                    $html: [{
                                        tag: 'span',
                                        $html: nb.bind('saleEmail')
                                    }, {
                                        tag: 'span',
                                        // 'class': 'uk-text-truncate',
                                        $text: nb.bind('salesEmail')
                                    }]
                                }]
                            }]
                        }]
                    }

                    ]
                }]
            }]
        }
    },
    method: {
        init: function () {
            var self = this;

            //语言切换
            this.$('languageText').on('click', function () {
                var model = self.getModel();
                model.set('requireSwitchLanguage');
            });

            //退出登录
            this.$('logOff').on('click', function () {
                nb.model.set('logOff', new Date());
            });
        }
    }
});

// , {
//     tag: 'a',
//         href: 'salesProductList.html?token=047220eb8b153fa17e86d217234daf98&userName=30010963&isSale=true',
//         $text: '销售登录（前端测试）'
// }, {
//     tag: 'a',
//         href: 'customerCompanyInfo.html?id=1-8DCZQ',
//         $text: '客户信息（前端测试）'
// }


//////////////////
// WEBPACK FOOTER
// ../src/js/view/Header.js
// module id = 20
// module chunks = 0 1 3 4 5 6 7 8 9 10 12 13 14 15 16 17 18 19 21 24 25 26 27 28 30 31 33 37 38